import React from 'react';

import { withAppStepsState } from "./../../../shared/containers/containerAppStepsState"
import { withStepsState } from "./../../../shared/containers/containerStepsState"
import getParameterFromURL from "../../../utils/getParameterFromUrl"

import styles from "./logoSteps.module.scss"

const LogoSteps = props => {
  const { isOpenAppSteps, onCloseApp, currentIndex } = props
  let firstQuestionC = (getParameterFromURL("firstQuestionC") === "true");
  let firstQuestionD = (getParameterFromURL("firstQuestionD") === "true");

  if (
    currentIndex === 0 && firstQuestionC
    ||
    currentIndex === 0 && firstQuestionD
    ) return '';

  return (
    <button
      className={styles.logoSteps}
      onClick={isOpenAppSteps ? onCloseApp : () => { }}
    >
      <img className={styles.logo} src="./img/logo.png" alt="verv" />
    </button>
  )
}

export default withAppStepsState(withStepsState(LogoSteps));